import { Navigate, useLocation } from 'react-router-dom'

export function LegacyEditRedirect({ tab }: { tab: 'enrollment' | 'corrections' }) {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.set('tab', tab)
  return <Navigate replace to={`/edit-student?${params.toString()}`} />
}
